<script setup lang="ts">
import { AppSwitcherItem, AppSwitcherList } from '@shared/ui/switchers'

import { useSwitcherSlotsTracker } from '../../model/shift-control/switcher-slots-tracker.hook'

defineOptions({
  name: 'SwitcherSlotsTracker',
})

const {
  options,
  disabled,
  setChangeSlot,
} = useSwitcherSlotsTracker()
</script>

<template>
  <AppSwitcherList>
    <AppSwitcherItem
      v-for="option in options"
      :key="option.text"
      :text="option.text"
      :selected="option.selected"
      :disabled="disabled"
      @click="setChangeSlot(option.from, option.to)"
    />
  </AppSwitcherList>
</template>
